import React, { useCallback, useRef } from 'react';
import styled from 'styled-components';
import Colors from './Colors';
import TextLink from './TextLink';

interface IconLinkProps {
  icon?: React.ReactNode;
  link?: string;
  text?: string;
  color?: string;
  hideMobileIcon?: boolean;
  onClick?: () => void;
}

const ControlIconLink: React.FC<IconLinkProps> = ({ icon, link, text, color = Colors.navyBlue, hideMobileIcon, onClick }) => {
  const linkRef = useRef<HTMLAnchorElement>(null);
  const onFinalClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      if (onClick) {
        onClick();
      } else if (linkRef.current) {
        linkRef.current.click();
      }
    },
    [onClick]
  );

  return (
    <Wrapper onClick={onFinalClick}>
      {icon && (
        <ControlIconWrapper $color={color} $hideMobileIcon={hideMobileIcon}>
          {icon}
        </ControlIconWrapper>
      )}
      <TextLink ref={linkRef} to={link || '#'} $color={color} $standard>
        {text || ''}
      </TextLink>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  a {
    padding: 4px 2px 0 0;
    font-family: 'BrownStd';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
  }

  &:hover {
    > * {
      opacity: 0.7;
    }

    a {
      text-decoration: none;
    }
  }
`;

const ControlIconWrapper = styled.div<{ $color?: string; $hideMobileIcon?: boolean }>`
  margin-right: 10px;
  height: 13px;
  width: 13px;

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }

  @media (max-width: 480px) {
    ${(props) => props.$hideMobileIcon && `display: none;`}
  }
`;

export default ControlIconLink;
